import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, httpResource, HttpResourceRef } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChallengeQuizQuestion, ChallengeResponse, SubmitChallengePayload } from '../interfaces/challenge-response.interface';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class ChallengeService {
  private http = inject(HttpClient);

  #challengesUrl = `${API_URL}/challenges`;

  getChallenges(): Observable<ChallengeResponse[]> {
    return this.http.get<ChallengeResponse[]>(`${this.#challengesUrl}/users`);
  }

  getCompletedChallenges(): Observable<ChallengeResponse[]> {
    return this.http.get<ChallengeResponse[]>(`${this.#challengesUrl}/completed`);
  }

  getProgressChallenges(): Observable<ChallengeResponse[]> {
    return this.http.get<ChallengeResponse[]>(`${this.#challengesUrl}/progress`);
  }

  getQuizChallengesResource(
    challengeId: () => string | undefined
  ): HttpResourceRef<ChallengeQuizQuestion[] | undefined> {
    return httpResource<ChallengeQuizQuestion[]>(
      () => {
        const id = challengeId();
        return id ? `${this.#challengesUrl}/quiz?Id=${id}` : undefined;
      }
    );
  }

  uploadChallengeFile(fd: FormData): Observable<string> {
    return this.http.post<string>(`${this.#challengesUrl}/image/upload`, fd);
  }


  submitChallenge(payload: SubmitChallengePayload): Observable<void> {
    return this.http.post<void>(`${this.#challengesUrl}/participations`, payload);
  }
}
      
  